import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";
import { DateTime } from "luxon";

import Localization from "../../localization";
import Button from "../button";
import Image from "../image";
import IconClose from "../icons/close";
import IconArrow from "../icons/arrow";
import { changeMobileClasse } from "../../redux/actions/options";
import { getLessons } from "../../redux/selectors/lessons";
import { fixExternalLinks } from "../../utils/helper";
import AccordionDescription from "../../screens/Classes/Calendar/AccordionDescription";

class MobileClasse extends Component {
    constructor(props) {
        super(props);

        this._onClose = this._onClose.bind(this);
        this._onNextClass = this._onNextClass.bind(this);
        this._onPrevClass = this._onPrevClass.bind(this);
    }

    _onClose() {
        this.props.changeMobileClasse(false);
    }

    _onNextClass(lesson) {
        const dt = DateTime.fromISO(lesson.date);

        this.props.changeMobileClasse(true, {
            selectedYear: dt.year,
            selectedMonth: dt.month,
            selectedDay: dt.day,
        });
    }

    _onPrevClass(lesson) {
        const dt = DateTime.fromISO(lesson.date);

        this.props.changeMobileClasse(true, {
            selectedYear: dt.year,
            selectedMonth: dt.month,
            selectedDay: dt.day,
        });
    }

    _renderLesson(lesson, last = false) {
        const { visible, locale, lessons, lessonDate } = this.props;

        let date = DateTime.fromISO(lesson.date);
        let isOver = false;
        //date.set({ hour: 9, minute: 30 }).diffNow("seconds").seconds < 0;

        return (
            <div className={`${!last && "border-b border-blue"} pb-32`}>
                {lesson.cover && (
                    <div className="mb-20">
                        <Image
                            alt={lesson.cover.alt || lesson.name}
                            url={lesson.cover.url}
                            aspectRatio="aspect-ratio-square"
                        />
                    </div>
                )}
                <div className="my-20">
                    <p className="font-bold">{lesson.teacher_name}</p>
                    <p className="font-bold">{lesson.name}</p>
                    <p className="font-bold">{lesson.time}</p>
                </div>
                <div className="mb-30 font-bold">
                    <p>
                        {Localization[locale].classes.price + ": "}
                        {lesson.price === 0
                            ? Localization[locale].classes.free
                            : lesson.price + " €"}
                    </p>
                    {lesson.space_id && !lesson.is_online && (
                        <p>
                            {Localization[locale].classes.local +
                                ": " +
                                lesson.space.name}
                        </p>
                    )}
                    {lesson.is_online && (
                        <p>{Localization[locale].classes.online}</p>
                    )}
                </div>
                {lesson.description && (
                    <AccordionDescription
                        id={lesson.id + "_description"}
                        locale={locale}
                        description={lesson.description}
                    />
                )}
                {lesson.biography && (
                    <AccordionDescription
                        id={lesson.id + "_biography"}
                        locale={locale}
                        description={lesson.biography}
                    />
                )}
                {!isOver && lesson.tickets_url && (
                    <Button
                        href={lesson.tickets_url}
                        text={
                            lesson.price > 0
                                ? Localization[locale].classes.buy
                                : Localization[locale].classes.reserve
                        }
                        textStyle={
                            "font-bold text-20 xl:text-23 z-10 transition text-white"
                        }
                        backgroundColor={"bg-blue"}
                        style={"flex-1 mt-30"}
                    />
                )}
            </div>
        );
    }

    render() {
        const { visible, locale, lessons, lessonDate } = this.props;

        if (!visible || !lessonDate) return null;

        const className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 z-20";

        let currentDay = DateTime.now().set({
            year: lessonDate.selectedYear,
            month: lessonDate.selectedMonth,
            day: lessonDate.selectedDay,
        });

        let lessonPrev = null;
        let lessonNext = null;

        let dayLessons = lessons.filter(function (item) {
            let date = DateTime.fromISO(item.date);

            return date.hasSame(currentDay, "day");
        });

        if (!dayLessons)
            return (
                <div className={className}>
                    <Helmet>
                        <body className="modal-open" />
                    </Helmet>
                    <div className="flex flex-col pt-30 pb-30 overflow-y-auto bg-pink px-16 w-full">
                        <div className="flex relative mb-40">
                            <div className="absolute right-0 top-0">
                                <Button
                                    icon={
                                        <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-pink text-blue" />
                                    }
                                    backgroundColorOver={"bg-pink"}
                                    onClick={this._onClose}
                                    style={"w-50"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );

        let firstLesson = dayLessons[0];
        let lastLesson = dayLessons[dayLessons.length - 1];

        let firstIndex = lessons.findIndex(l => l.id === firstLesson.id);
        let lastIndex = lessons.findIndex(l => l.id === lastLesson.id);
        if (firstIndex > 0) {
            lessonPrev = lessons[firstIndex - 1];
        }
        if (lastIndex < lessons.length - 1) {
            lessonNext = lessons[lastIndex + 1];
        }

        return (
            <div className={className}>
                <Helmet>
                    <body className="modal-open" />
                </Helmet>
                <div className="flex flex-col pt-30 pb-84 overflow-y-auto bg-pink px-16 w-full">
                    <div className="flex relative mb-20">
                        <p className="text-30 text-blue uppercase font-judge font-bold flex-1">
                            {currentDay
                                .toLocaleString({ dateStyle: "short" })
                                .split("/")
                                .join(".")}
                            <br />
                            {currentDay.toLocaleString({ weekday: "long" })}
                        </p>
                        <div className="absolute right-0 top-0">
                            <Button
                                icon={
                                    <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-blue text-blue" />
                                }
                                backgroundColorOver={"bg-pink"}
                                onClick={this._onClose}
                                style={"w-50"}
                            />
                        </div>
                    </div>
                    <div className="space-y-30">
                        {dayLessons.map((lesson, index) =>
                            this._renderLesson(
                                lesson,
                                index === dayLessons.length - 1
                            )
                        )}
                    </div>
                    <div className="z-30 fixed flex justify-between items-center bg-pink p-16 bottom-0 left-0 right-0 xl:hidden">
                        <p className="font-bold">
                            {dayLessons.length === 1
                                ? dayLessons.length +
                                  " " +
                                  Localization[locale].classes.practice
                                : dayLessons.length +
                                  " " +
                                  Localization[locale].classes.practices}
                        </p>
                        <div className="flex">
                            <Button
                                icon={
                                    <IconArrow
                                        className={
                                            "w-26 h-26 z-10 transition hover-hover:group-hover:text-white text-blue transform -rotate-90"
                                        }
                                    />
                                }
                                disable={!lessonPrev}
                                onClick={() => {
                                    this._onPrevClass(lessonPrev);
                                }}
                                style={"w-70"}
                            />
                            <Button
                                icon={
                                    <IconArrow
                                        className={
                                            "w-26 h-26 z-10 transition hover-hover:group-hover:text-white text-blue transform rotate-90"
                                        }
                                    />
                                }
                                disable={!lessonNext}
                                onClick={() => {
                                    this._onNextClass(lessonNext);
                                }}
                                style={"w-70 ml-12"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    visible: state.options.isMobileClasseVisible,
    lessonDate: state.options.lessonDate,
    lessons: getLessons(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeMobileClasse,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileClasse);
